import { InfoIconWrapper } from "@components/bronson/InfoIconWrapper";

interface Props {
  id?: string;
  text: string;
  htmlFor?: string;
  className?: string;
  infoIconText?: React.ReactNode;
}

export const Label = ({ id, text, htmlFor, className, infoIconText }: Props) => {
  let labelText = <span>{text}</span>;
  if (text.endsWith(" *")) {
    labelText = <span>{text.slice(0, -2)}&nbsp;*</span>;
  }

  return (
    <>
      {!infoIconText && (
        <label id={id} htmlFor={htmlFor} className={className}>
          {labelText}
        </label>
      )}
      {infoIconText && (
        <div style={{ display: "flex" }}>
          <label id={id} htmlFor={htmlFor} className={`${className} u-mr-xsmall`}>
            {labelText}
          </label>
          <span>
            <InfoIconWrapper tabIndex={-1} icon="semantic-info">
              {infoIconText}
            </InfoIconWrapper>
          </span>
        </div>
      )}
    </>
  );
};
